module.exports = require("canvg");